import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { formatPhoneNumber } from "../../../../utils/NumberHelpers";
import Columns from "../../Columns";
import ContentContainer from "../../ContentContainer";
import InfoIcon from "../../icons/InfoIcon";
import LinkComponent from "../../LinkComponent";
import NewHeadline from "../../NewHeadline";
import { SideNavContainer } from "../SideNavContainer";
import useSideNavStore from "../SideNavContainer/store";
import ContactForm from "./ContactForm";

const Content = styled(ContentContainer)`
    font-family: var(--font-family-vito);
    background-color: ${({ theme }) => theme.colors.grey.toString()};
`;

const FormContainer = styled.div`
    padding: 20px;
    background-color: ${({ theme }) => theme.colors.white.toString()};
`;

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;

    svg {
        width: auto;
        height: 60%;
    }
`;

const HiddenFromMedium = styled.span`
    ${({ theme }) => theme.breakpoints.from.medium.css`
        display: none !important;
    `}
`;

const HiddenUpToSmall = styled.span`
    ${({ theme }) => theme.breakpoints.upTo.small.css`
        display: none;
    `}
`;

const HiddenWithSideNav = styled.span`
    .side-nav-element & {
        @media (min-width: 960px) and (max-width: 1585px) {
            display: none;
        }
    }
`;

const PrebuiltContactForm = ({
    email,
    phone,
    teamName,
    contactFormName,
    useFormalAddress = false,
    lang = "de",
    name,
}) => {
    const theme = useTheme();
    const [paddingLeft] = useSideNavStore((state) => [state.paddingLeft]);
    const linkCss = css`
        padding: 10px 0;
        color: ${theme.colors.blue.toString()};
        white-space: nowrap;
    `;

    return (
        <Content>
            <SideNavContainer paddingLeft={paddingLeft}>
                <Columns>
                    <Columns.Column>
                        <Columns className="is-mobile">
                            <Columns.Column
                                className="is-three-fifth"
                                css={css`
                                    margin-top: 18px;
                                `}
                            >
                                <NewHeadline is="3" looklike>
                                    {/* Variable name should be changed because the whole line comes from the CMS */}
                                    {teamName}
                                </NewHeadline>
                                {phone && (
                                    <LinkComponent
                                        leftIcon
                                        link={{
                                            href:
                                                "tel:" +
                                                formatPhoneNumber(phone, true),
                                            text: phone,
                                        }}
                                        icon="phone"
                                        linkItemCss={linkCss}
                                        moveIcon={false}
                                        bold={false}
                                        fontSize="1.5rem"
                                    />
                                )}
                                <LinkComponent
                                    leftIcon
                                    link={{
                                        href: "mailto:" + String(email),
                                        text: email,
                                    }}
                                    icon="mail"
                                    linkItemCss={linkCss}
                                    moveIcon={false}
                                    bold={false}
                                    fontSize="1.5rem"
                                />
                            </Columns.Column>

                            <Columns.Column className="is-one-fifth-mobile">
                                <HiddenFromMedium>
                                    <IconContainer>
                                        <InfoIcon />
                                    </IconContainer>
                                </HiddenFromMedium>
                            </Columns.Column>
                        </Columns>
                    </Columns.Column>
                    <Columns.Column desktop="half" tablet="full">
                        <FormContainer>
                            <ContactForm
                                {...{ contactFormName }}
                                useFormalAddress={useFormalAddress}
                                lang={lang}
                                name={name}
                            />
                        </FormContainer>
                    </Columns.Column>
                    <Columns.Column desktop="one-fifth">
                        <HiddenWithSideNav>
                            <HiddenUpToSmall>
                                <IconContainer>
                                    <InfoIcon />
                                </IconContainer>
                            </HiddenUpToSmall>
                        </HiddenWithSideNav>
                    </Columns.Column>
                </Columns>
            </SideNavContainer>
        </Content>
    );
};
export default PrebuiltContactForm;
